import { Counter } from './config/ui/counter/counter';
import { Explorer } from './config/ui/explorer/explorer';
import { Header } from './config/ui/header/header';
import { Layout } from './config/ui/layout';

export function SilobagList() {
  return (
    <Layout>
      <Header />
      <Counter />
      <Explorer />
    </Layout>
  );
}
